import { pluginFactoryNoConfig } from 'bootstrap-vue/src/utils/plugins'

import { BIcon } from 'bootstrap-vue/src/icons/icon'
import { BIconstack } from 'bootstrap-vue/src/icons/iconstack'
import * as BootstrapIcons from 'bootstrap-vue/src/icons/icons'
import CustomIcons from './custom-icons'

// Bootstrap-Icons müssen als BIcon… registriert sein, sonst findet <b-icon icon="foo"> die Komponente nicht (nur BIconBlank).
// Zusätzliche BIconB…-Aliase bleiben für evtl. alte Verweise. Custom-SVGs aus public/icons überschreiben Namenskollisionen (z. B. plus.svg).
const bootstrapByName = Object.keys(BootstrapIcons).reduce((acc, iKey) => {
  acc[iKey] = BootstrapIcons[iKey]
  acc[iKey.replace(/^BIcon/, 'BIconB')] = BootstrapIcons[iKey]
  return acc
}, {})

const Icons = Object.assign(bootstrapByName, CustomIcons)

export const iconNames = Object.keys(Icons)

export const iconNamesKebab = iconNames.map(name => name.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase().replace(/^-/g, ''))

export const normalizedIconNames = iconNamesKebab.map(n => n.replace(/^b-icon-/, ''))

export const IconsPlugin = pluginFactoryNoConfig({
  components: {
    BIcon,
    BIconstack,
    ...Icons
  }
})

export const BootstrapVueIcons = pluginFactoryNoConfig(
  { plugins: { IconsPlugin } },
  { NAME: 'BootstrapVueIcons' }
)
